import { ROUTE } from "../../../routes";
import { TARGET_PAGES } from "../../../configs/constants";
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const navigateToPayment = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.PAYMENT_START, { target: TARGET_PAGES.REPAYMENT });
};
export const navigateToForeclsure = async (action, _datastore, { navigate, instrumentTrack }) => {
    await navigate(ROUTE.FORECLOSURE_NEW, { isFromFaq: true });
    await instrumentTrack('PROCEED_TO_CLOSE_LOAN_BUTTON_CLICKED');
};
export const trackFaq = async (action, _datastore, { instrumentTrack }) => {
    const type = action?.payload?.type;
    const eventProverty = action?.payload?.eventProverty;
    const result = action?.payload?.result;
    const question = action?.payload?.question;
    await instrumentTrack(type, {
        [eventProverty]: result,
        question: question,
    });
};
